<template>
    <div class="w-full flex flex-col pt-6 bg-gradient-to-b from-stone-200 to-stone-400 dark:from-stone-800 dark:to-stone-900 justify-center items-center text-center">
        <p class="text-stone-950 dark:text-stone-300 font-thin text-shadow-special">
            Copyright © 2025 Alexandre Vivier - Tous droits réservés.
        </p>
        <p>
            <span class="text-stone-950 dark:text-stone-300 font-thin text-shadow-special">
       Site et assets graphiques par  
            </span>
            <a href="https://alexandrevivier.fr/" class="text-sky-700 dark:text-sky-400 font-semibold uppercase">
            
                <span role="img" aria-label="loupe">🔍</span>
            Alexandre Vivier - Krill
            </a>
        </p>
    </div>  
</template>
<script lang="js" setup></script>